/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * scrollTrigger.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * Import scrollTrigger.js bundle
 */
import { scrollTriggerParallax } from "./scrollTrigger/scrollTrigger-parallax";
import { scrollSlideText } from "./scrollTrigger/scrollTrigger-slideText";
import { setTrigger, setScrubTrigger } from "./scrollTrigger/scrollTrigger-trigger";
/**
 * scrollTrigger
 */
const setScrollTrigger = () => {
	scrollTriggerParallax();
	scrollSlideText();
	setTrigger();
	setScrubTrigger();
};

/**
 * Export.
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
export { setScrollTrigger };
